import Language from '../../../language/language.json';

const signInStart = () => {
    return {
        type : 'SIGNIN_START'
    }
}

const signInSuccess = () => {
    return {
        type : 'SIGNIN_SUCCESS'
    }
}
const signInFail = (message) => {
    return {
        type : 'SIGNIN_FAIL',
        payload : {
            message  
        }
    }
}

export const signIn = (email, password) => {
   return (dispatch, getState, getFirebase) => {
       const {language} = getState().universal;

       dispatch(signInStart());

        const firebase = getFirebase();
        firebase.auth().signInWithEmailAndPassword(email, password)
            .then( () => {
                dispatch(signInSuccess());
            })
            .catch((e) => {
                let message = '';
                switch(e.code) {
                    case "auth/invalid-email" : {
                        message = Language.signIn.fail.invalidEmail[language];
                    }break;
                    case "auth/user-disabled" : {
                        message = Language.signIn.fail.userDisabled[language];
                    }break;
                    case "auth/user-not-found" : { 
                        message = Language.signIn.fail.userNotFound[language];
                    }break;
                    case "auth/wrong-password" : {
                        message = Language.signIn.fail.wrongPassword[language];
                    }break;
                    default : {
                    }break;
                }
                dispatch(signInFail(message));
            })
   } 
}


// WEBPACK FOOTER //
// ./src/components/SignIn/actions/signInActions.js